// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"195":"0b1dd51f","686":"691861d7","932":"3fa5db43"}[chunkId] + ".css";
};